/**
 * @generated SignedSource<<739c186db01ce47bacc6a8cffb260e98>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SetAnswerInTextQuestionInput = {
  clientMutationId?: string | null;
  givenAnswer: PotentialAnalysisTextGivenAnswerInput;
  learnPotentialAnalysisId: string;
  questionId: string;
  questionText: string;
};
export type PotentialAnalysisTextGivenAnswerInput = {
  text: string;
};
export type textQuestion_SetAnswerInTextQuestionMutation$variables = {
  input: SetAnswerInTextQuestionInput;
};
export type textQuestion_SetAnswerInTextQuestionMutation$data = {
  readonly PotentialAnalysis: {
    readonly setAnswerInTextQuestion: {
      readonly question: {
        readonly givenAnswer: {
          readonly text: string;
        } | null;
        readonly id: string;
      } | null;
    } | null;
  };
};
export type textQuestion_SetAnswerInTextQuestionMutation = {
  response: textQuestion_SetAnswerInTextQuestionMutation$data;
  variables: textQuestion_SetAnswerInTextQuestionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "PotentialAnalysisMutations",
    "kind": "LinkedField",
    "name": "PotentialAnalysis",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "SetAnswerInTextQuestionPayload",
        "kind": "LinkedField",
        "name": "setAnswerInTextQuestion",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PotentialAnalysisTextQuestion",
            "kind": "LinkedField",
            "name": "question",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PotentialAnalysisTextGivenAnswer",
                "kind": "LinkedField",
                "name": "givenAnswer",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "text",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "textQuestion_SetAnswerInTextQuestionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "textQuestion_SetAnswerInTextQuestionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7dbdaac3c192907cb9662f5820d95915",
    "id": null,
    "metadata": {},
    "name": "textQuestion_SetAnswerInTextQuestionMutation",
    "operationKind": "mutation",
    "text": "mutation textQuestion_SetAnswerInTextQuestionMutation(\n  $input: SetAnswerInTextQuestionInput!\n) {\n  PotentialAnalysis {\n    setAnswerInTextQuestion(input: $input) {\n      question {\n        id\n        givenAnswer {\n          text\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b03fb5067d420a434545acd8c463b3b2";

export default node;
